import warn from '../warn';
import { defaultLocale } from './consts';
import type { TranslationFileLoader } from './types';

export const createTranslationLoader =
  ({
    translationFileLoader,
  }: {
    translationFileLoader: TranslationFileLoader;
  }) =>
  (locale: string) => {
    try {
      return translationFileLoader({ locale });
    } catch (e) {
      warn(
        `Locale has changed to '${locale}' but the component doesn't have the correct localization file for it.`
      );
      return translationFileLoader({ locale: defaultLocale });
    }
  };
